module.exports = __webpack_public_path__ + "static/WEDDING E&M-452-e59aff1c65dcfa4295f0bb829af781cc.jpg";